// Match React Native Web's default text family. Native text keeps the platform
// system font; raw HTML controls must explicitly use the same family on web.
export const WEB_FONT_FAMILY='-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
